import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Button, Modal, Spinner, Link } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { ExternalLinkModalContext } from "@/basic/context";

const TRANSLATION_PATH = "EXTERNAL_LINK_MODAL";

export const ExternalLinkModal = () => {
  const { isOpen, manualRedirectTo, close } = useContext(ExternalLinkModalContext);
  const { t: translate } = useTranslation();

  const handleClickManualRedirect = () => {
    if (typeof manualRedirectTo === "string") {
      window.open(manualRedirectTo);
    } else if (manualRedirectTo && typeof manualRedirectTo === "object") {
      const url = `${manualRedirectTo.pathname ?? ""}` + `${manualRedirectTo.search ?? ""}` + `${manualRedirectTo.hash ?? ""}`;
      window.open(url);
    }
    close();
  };

  return (
    <Modal visible={isOpen} size="wide">
      <Stack alignment="center">
        <Spinner />
        <Semibold>{translate(`${TRANSLATION_PATH}.openingExternalLink`)}</Semibold>
        <Body textAlign="center">{translate(`${TRANSLATION_PATH}.beingRedirected`)}</Body>
        <Body textAlign="center">
          <Link to={manualRedirectTo} onClick={handleClickManualRedirect}>
            {translate(`${TRANSLATION_PATH}.clickHere`)}
          </Link>{" "}
          {translate(`${TRANSLATION_PATH}.ifYouArentRedirected`)}
        </Body>
        <Body textAlign="center">
          <Button appearance="text" onClick={() => close()}>
            {translate(`${TRANSLATION_PATH}.cancelRedirect`)}
          </Button>
        </Body>
      </Stack>
    </Modal>
  );
};
